import styled from 'styled-components';

const StyledContentWrapper = styled.div`
    flex: 1;
`;

export default StyledContentWrapper;
